// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** silence is golden **/

#clgo {
  z-index: 900 !important;
}

iframe.expanded-height {
  max-width: 70% !important;
  left: 10%;
  height: 90% !important;
  right: 10px !important;
  border-radius: 7px 7px 0 0;
  margin: 0 auto;
}
iframe.fixed-height {
  height: 98% !important;
}

i.icon-cancelar{
  display:none;
}

#mfe-dashboard {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/** silence is golden **/\n\n#clgo {\n  z-index: 900 !important;\n}\n\niframe.expanded-height {\n  max-width: 70% !important;\n  left: 10%;\n  height: 90% !important;\n  right: 10px !important;\n  border-radius: 7px 7px 0 0;\n  margin: 0 auto;\n}\niframe.fixed-height {\n  height: 98% !important;\n}\n\ni.icon-cancelar{\n  display:none;\n}\n\n#mfe-dashboard {\n  width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
